'use strict';

function sessionResponseInterceptor ($q, $window, $location) {
  function reject(response) {
    if($location.path().indexOf('login') > -1 || $location.path().indexOf('acceptinvite') > -1
      || $location.path().indexOf('setpassword') > -1 || $location.path().indexOf('forgotpassword') > -1) {
      return $q.reject(response);
    }

    if (response.status === 401 || response.status === 403) {
      $window.location = '/#/login';
    }

    return $q.reject(response);
  }

  return {
    'requestError': reject,
    'responseError': reject
  };
}

module.exports = sessionResponseInterceptor;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/providers/session-response-interceptor/index.js
 ** module id = 312
 ** module chunks = 0
 **/